import type { PropsWithChildren, ReactNode } from 'react';

type ShowProps = {
  when: boolean;
  fallback?: ReactNode;
} & PropsWithChildren;

export function Show({ when, children, fallback = null }: ShowProps) {
  if (when) {
    return children;
  }

  return fallback;
}
